import { defineComponent as _defineComponent } from 'vue'
import VehicleOptionVehicleList from "@/components/VehicleOptionVehicleList.vue";
import VehicleOptionImage from "@/components/VehicleOptionImage.vue";
import { computed } from "vue";
import { VehicleTypeKey } from "@/utils/enum";
import { SalesBotAmenityOption } from "@/models/dto/SalesbotV2VehicleOptions";
import { SpecialRequirement } from "@/models/dto/SalesBotRequirements";
import { useTheme } from "@/composables/useTheme";
import { getRequirementIconByKey } from "@/utils/icon";
import { getAmenityIconByKey } from "@/utils/amenity";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotTripSummaryDetails',
  props: {
    passengers: null,
    specialRequirements: null,
    amenities: null
  },
  setup(__props: any) {

const props = __props as {
  passengers?: number,
  specialRequirements: SpecialRequirement[],
  amenities: SalesBotAmenityOption[]
};

const { themes } = useTheme()




return { __sfc: true,themes, props, getRequirementIconByKey, getAmenityIconByKey }
}

})